export enum UserRole {
  Administrator = 'Administrator',
  SuperAdministrator = 'SuperAdministrator',
  MunicipalityAdmin = 'MunicipalityAdmin',
}

export enum StorageKeys {
  session_token = 'session-token',
}

export type serverError = { status: number; data: null; message: string };

export type ErrorMessage = { [key: string]: { [errorKey: string]: string } };

export type StringOrNull = string | null;
export type NumberOrNull = number | null;
export type DateOrNull = Date | null;
export type BoolOrNull = boolean | null;
